import { defineComponent as _defineComponent } from 'vue';
import { SLoader } from '@strana-artw/ui-kit';
export default /*#__PURE__*/_defineComponent({
  __name: 'PreLoader',
  setup: function setup(__props) {
    return {
      __sfc: true,
      SLoader: SLoader
    };
  }
});